import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { mergeLanding } from "@/lib/landingDefaults";
import { useWhatsAppConfig } from "@/components/WhatsAppButton";
import { Header, Hero, QuickEnquiry, Featured, Packages, Deals, WhyJoin, CustomPlan, Partner, Footer } from "@/components/landing/Sections";

const SECTIONS = { hero: Hero, quick: QuickEnquiry, featured: Featured, packages: Packages, deals: Deals,
                   why: WhyJoin, custom: CustomPlan, partner: Partner };

export default function Landing() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const preview = params.get("preview") === "draft" && user?.role === "admin";
  const [content, setContent] = useState(() => mergeLanding({}));
  const wa = useWhatsAppConfig();
  const waNumber = wa?.enabled ? wa.number : null;

  useEffect(() => {
    if (!user || params.get("preview")) return;
    if (user.role === "customer") nav("/customer");
    else if (user.role === "admin") nav("/admin");
    else if (user.role === "staff") nav("/staff");
  }, [user, nav, params]);

  useEffect(() => {
    const req = preview ? api.get("/admin/landing").then(({ data }) => data.draft) : api.get("/public/landing").then(({ data }) => data);
    req.then((saved) => setContent(mergeLanding(saved))).catch(() => {});
  }, [preview]);

  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 600);
    return () => clearTimeout(t);
  }, [content]);

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text)" }} data-testid="landing-page">
      {preview && <div className="bg-amber-400 text-amber-950 text-center text-xs font-semibold py-1.5" data-testid="preview-banner">DRAFT PREVIEW — not visible to visitors until published</div>}
      <Header c={content.header} />
      {content.order.filter((id) => !content.hidden?.[id]).map((id) => {
        const S = SECTIONS[id];
        return S ? <S key={id} c={content[id]} wa={waNumber} /> : null;
      })}
      <Footer c={content.footer} wa={waNumber} />
    </div>
  );
}
